import React, { useState, useEffect, useCallback } from 'react';

const AboutLexiSection: React.FC = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [showGallery, setShowGallery] = useState(false);
  
  const images = [
    {
      url: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/197aa4670cd8c77f3ec17bbe1e8854d0.jpeg",
      caption: "Smile That Lights Up A Room"
    },
    {
      url: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/7ed0e934e77035ad079182004f74e38f.jpeg",
      caption: "Natural Beauty"
    },
    {
      url: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/70f7d40d4a8e4f27cc08013bc82afbdc.jpeg",
      caption: "The most gorgeous travel partner"
    },
    {
      url: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/21c7012ea0bed5b86fd2cb4aabb86ee4.jpeg",
      caption: "Top Tier Rummy player"
    },
    {
      url: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/f0bdb7e49427aa74e1ee0640c1ed5868.jpeg",
      caption: "Amazing with kids"
    },
    {
      url: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/a29f76ab16fb8840d965a9c9373c4d56.jpeg",
      caption: "Crushes In A Ballgown"
    },
    {
      url: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/b777b0aa0a37a772e2817a6d85dd567b.jpeg",
      caption: "Tiny. Fits Easily on Small Planes"
    },
    {
      url: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/118d87f6a15435f82e057ba4070c85f7.jpeg",
      caption: "Makes Exploring Fun"
    }
  ];

  const nextImage = useCallback(() => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  }, [images.length]);

  const prevImage = useCallback(() => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  }, [images.length]);

  const openGallery = () => {
    setShowGallery(true);
    document.body.style.overflow = 'hidden';
  };

  const closeGallery = useCallback(() => {
    setShowGallery(false);
    document.body.style.overflow = 'unset';
  }, []);

  // Keyboard navigation
  useEffect(() => {
    if (!showGallery) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeGallery();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showGallery, closeGallery, prevImage, nextImage]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <>
      <section id="about" className="py-24 bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 relative overflow-hidden">
        {/* ... existing code ... */}
        
        {/* Dramatic Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-32 left-20 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-32 right-10 w-80 h-80 bg-pink-500/30 rounded-full blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/10 rounded-full blur-3xl animate-pulse delay-500"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-1/4 text-4xl animate-bounce">💎</div>
          <div className="absolute top-40 right-1/4 text-3xl animate-pulse">👑</div>
          <div className="absolute bottom-32 left-1/3 text-5xl animate-bounce delay-700">⚡</div>
          <div className="absolute bottom-20 right-1/4 text-3xl animate-ping">🔥</div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-20">
            <div className="inline-block bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full px-8 py-3 mb-8 border-4 border-white">
              <span className="text-black font-black text-sm uppercase tracking-wider">💎 MEET LEXI 💎</span>
            </div>
            
            <h2 className="text-6xl lg:text-7xl font-black text-white mb-8 leading-tight">
              She Built a
              <span className="block text-transparent bg-gradient-to-r from-yellow-300 via-pink-300 to-purple-300 bg-clip-text animate-pulse">
                Multi-Million Dollar Empire
              </span>
            </h2>
            
            <div className="bg-gradient-to-r from-purple-600/30 to-pink-600/30 backdrop-blur-md rounded-3xl p-8 border-4 border-white/30 shadow-2xl max-w-5xl mx-auto">
              <p className="text-3xl text-white font-black leading-relaxed mb-4">
                She Built a Multi-Million Dollar Empire 💼
              </p>
              <p className="text-2xl text-yellow-300 font-bold">
                Now She's Ready to Build Something Beautiful With YOU 💕
              </p>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-20 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <div className="bg-gradient-to-br from-red-500/20 to-pink-500/20 backdrop-blur-md rounded-3xl p-8 border-4 border-red-400/50 shadow-2xl">
                <div className="text-center mb-6">
                  <div className="text-6xl mb-4">🚨</div>
                  <h3 className="text-3xl font-black text-white mb-4">WHY SHE'S INCREDIBLE</h3>
                </div>
                
                <div className="space-y-4">
                  <div className="bg-white/10 rounded-2xl p-4 border-2 border-white/30">
                    <p className="text-xl text-white font-bold">
                      💰 <span className="text-yellow-300">CHIEF OF STAFF</span> - $20M company
                    </p>
                  </div>
                  <div className="bg-white/10 rounded-2xl p-4 border-2 border-white/30">
                    <p className="text-xl text-white font-bold">
                      🎓 <span className="text-yellow-300">FINANCE MAJOR</span> - Brilliant mind for numbers
                    </p>
                  </div>
                  <div className="bg-white/10 rounded-2xl p-4 border-2 border-white/30">
                    <p className="text-xl text-white font-bold">
                      👨‍👩‍👧‍👦 <span className="text-yellow-300">AMAZING FAMILY</span> - Raised with incredible values
                    </p>
                  </div>
                  <div className="bg-white/10 rounded-2xl p-4 border-2 border-white/30">
                    <p className="text-xl text-white font-bold">
                      ✈️ <span className="text-yellow-300">WORLD TRAVELER</span> - Passport full of adventures
                    </p>
                  </div>
                  <div className="bg-white/10 rounded-2xl p-4 border-2 border-white/30">
                    <p className="text-xl text-white font-bold">
                      ⚽ <span className="text-yellow-300">NEWCASTLE UNITED FAN</span> - Passionate & loyal
                    </p>
                  </div>
                  <div className="bg-white/10 rounded-2xl p-4 border-2 border-white/30">
                    <p className="text-xl text-white font-bold">
                      🌶️ <span className="text-yellow-300">SRIRACHA IN HER PURSE</span> - Spicy personality
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-blue-500/20 to-cyan-500/20 backdrop-blur-md rounded-3xl p-8 border-4 border-blue-400/50 shadow-2xl">
                <div className="text-center mb-6">
                  <div className="text-5xl mb-4">👨‍👩‍👧‍👦</div>
                  <h3 className="text-2xl font-black text-white mb-4">RAISED BY AMAZING PARENTS</h3>
                </div>
                <p className="text-lg text-white font-bold leading-relaxed text-center">
                  The Geraghty family is the real deal - loving, supportive, and successful. They raised a daughter who values loyalty, hard work, and genuine connections.
                  <span className="block mt-4 text-yellow-300 text-xl">Family comes first, always.</span>
                </p>
              </div>

              <div className="bg-gradient-to-br from-green-500/20 to-emerald-500/20 backdrop-blur-md rounded-3xl p-8 border-4 border-green-400/50 shadow-2xl">
                <div className="text-center mb-6">
                  <div className="text-5xl mb-4">💎</div>
                  <h3 className="text-2xl font-black text-white mb-4">THE COMPLETE PACKAGE</h3>
                </div>
                <p className="text-lg text-white font-bold leading-relaxed text-center">
                  Beautiful, brilliant, successful, and from an amazing family. She's been so focused on crushing it professionally that dating took a backseat. 
                  <span className="block mt-4 text-yellow-300 text-xl">Now she's ready to meet the RIGHT person.</span>
                </p>
              </div>

              <div className="bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur-md rounded-3xl p-8 border-4 border-purple-400/50 shadow-2xl">
                <div className="text-center mb-6">
                  <div className="text-5xl mb-4">🔥</div>
                  <h3 className="text-2xl font-black text-white mb-4">WHAT MAKES HER SPECIAL</h3>
                </div>
                <p className="text-lg text-white font-bold leading-relaxed text-center">
                  From Granite Bay to global success, with a family that's her foundation. She's the woman who carries sriracha packets, cheers for Newcastle United, and runs operations at a $20M company.
                  <span className="block mt-4 text-yellow-300 text-xl">She's looking for someone equally extraordinary.</span>
                </p>
              </div>

              <div 
                className="bg-gradient-to-br from-yellow-500/20 to-orange-500/20 backdrop-blur-md rounded-3xl p-8 border-4 border-yellow-400/50 shadow-2xl cursor-pointer hover:scale-105 transition-all duration-300 transform hover:shadow-yellow-400/50"
                onClick={openGallery}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    openGallery();
                  }
                }}
              >
                <div className="text-center mb-6">
                  <div className="text-5xl mb-4">📸</div>
                  <h3 className="text-2xl font-black text-white mb-4">REAL PHOTOS, REAL WOMAN</h3>
                </div>
                <p className="text-lg text-white font-bold leading-relaxed text-center">
                  These are candid photos we have taken of our Lexi through the years! This is the amazing woman we know and love.
                  <span className="block mt-4 text-yellow-300 text-xl">Authentic, stunning, successful, and ready to find her person.</span>
                </p>
                <div className="text-center mt-6">
                  <span className="inline-flex items-center text-yellow-300 font-bold text-lg animate-pulse">
                    <i className="ri-image-line mr-2 text-2xl"></i>
                    Click to View Gallery ({images.length} Photos)
                  </span>
                </div>
              </div>
            </div>

            {/* Right Image Gallery */}
            <div className="relative">
              <div className="relative">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
                  <img 
                    src={images[currentImage].url}
                    alt={images[currentImage].caption}
                    className="w-full h-[600px] object-cover object-center transition-all duration-500"
                    style={{
                      filter: 'contrast(1.2) saturate(1.3) brightness(1.08) hue-rotate(3deg) drop-shadow(0 10px 20px rgba(0,0,0,0.3))'
                    }}
                  />
                  
                  {/* Navigation Arrows on Main Image */}
                  <button
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/60 hover:bg-black/80 backdrop-blur-sm rounded-full p-3 text-white hover:text-yellow-300 transition-all duration-300 shadow-xl border-2 border-white/30 z-10"
                    aria-label="Previous image"
                  >
                    <i className="ri-arrow-left-line text-2xl"></i>
                  </button>
                  
                  <button
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/60 hover:bg-black/80 backdrop-blur-sm rounded-full p-3 text-white hover:text-yellow-300 transition-all duration-300 shadow-xl border-2 border-white/30 z-10"
                    aria-label="Next image"
                  >
                    <i className="ri-arrow-right-line text-2xl"></i>
                  </button>
                  
                  {/* Image Caption */}
                  <div className="absolute bottom-6 left-6 right-6">
                    <div className="bg-gradient-to-r from-purple-600/90 to-pink-600/90 backdrop-blur-sm rounded-2xl p-6 border-2 border-white/50 shadow-2xl">
                      <p className="text-white font-black text-xl text-center">
                        {images[currentImage].caption}
                      </p>
                      <p className="text-yellow-300 font-bold text-sm text-center mt-2">
                        Real photos from friends 📸 • {currentImage + 1} of {images.length}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Image Navigation */}
              <div className="flex justify-center space-x-4 mt-8">
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImage(index)}
                    className={`w-4 h-4 rounded-full transition-all duration-300 border-2 border-white ${
                      currentImage === index 
                        ? 'bg-yellow-400 scale-125' 
                        : 'bg-white/30 hover:bg-white/60'
                    }`}
                  />
                ))}
              </div>

              {/* Floating Achievement Badges */}
              <div className="absolute -top-8 -left-8 bg-gradient-to-br from-green-400 to-emerald-500 rounded-2xl p-6 shadow-2xl border-4 border-white transform rotate-12">
                <div className="text-center">
                  <div className="text-3xl mb-2">🎓</div>
                  <div className="font-black text-white text-lg">SDSU</div>
                  <div className="text-white font-bold text-sm">Graduate</div>
                </div>
              </div>

              <div className="absolute -bottom-8 -right-8 bg-gradient-to-br from-red-400 to-pink-500 rounded-2xl p-6 shadow-2xl border-4 border-white transform -rotate-12">
                <div className="text-center">
                  <div className="text-3xl mb-2">🌶️</div>
                  <div className="font-black text-white text-lg">SPICY</div>
                  <div className="text-white font-bold text-sm">Personality</div>
                </div>
              </div>

              <div className="absolute top-1/2 -right-12 bg-gradient-to-br from-purple-400 to-indigo-500 rounded-2xl p-6 shadow-2xl border-4 border-white transform rotate-6">
                <div className="text-center">
                  <div className="text-3xl mb-2">💼</div>
                  <div className="font-black text-white text-lg">EXEC</div>
                  <div className="text-white font-bold text-sm">Level</div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-20">
            <div className="relative">
              <div className="absolute -inset-4 md:-inset-8 bg-gradient-to-r from-yellow-400 via-red-500 to-pink-500 rounded-3xl blur-2xl opacity-75 animate-pulse"></div>
              <div className="relative bg-gradient-to-br from-purple-600/30 to-pink-600/30 backdrop-blur-md rounded-3xl p-6 md:p-12 border-4 border-white/50 shadow-2xl max-w-4xl mx-auto">
                <div className="text-4xl md:text-6xl mb-4 md:mb-6">🔥</div>
                <h3 className="text-2xl md:text-4xl lg:text-5xl font-black text-white mb-6 md:mb-8 leading-tight px-2">
                  Could You Be The One?
                </h3>
                <p className="text-lg md:text-2xl text-yellow-300 mb-6 md:mb-8 font-bold px-2">
                  She's looking for someone special - show her who you are
                </p>
                <button 
                  onClick={() => document.getElementById('application')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-6 md:px-16 py-4 md:py-6 rounded-2xl font-black text-lg md:text-2xl hover:from-yellow-300 hover:to-orange-400 transition-all duration-300 transform hover:scale-110 shadow-2xl border-4 border-white whitespace-nowrap"
                >
                  🔥 COULD YOU BE THE ONE? 🔥
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Photo Gallery Modal */}
      {showGallery && (
        <div 
          className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={closeGallery}
        >
          <div 
            className="relative max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closeGallery}
              className="absolute -top-16 right-0 text-white hover:text-yellow-300 transition-colors z-10 bg-black/50 rounded-full p-2 backdrop-blur-sm"
              aria-label="Close gallery"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>

            {/* Main Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-black">
              <img
                src={images[currentImage].url}
                alt={images[currentImage].caption}
                className="w-full h-[75vh] object-contain"
                style={{
                  filter: 'contrast(1.2) saturate(1.3) brightness(1.08) hue-rotate(3deg)'
                }}
              />
              
              {/* Image Caption */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6">
                <h3 className="text-white font-black text-2xl text-center">
                  {images[currentImage].caption}
                </h3>
                <p className="text-yellow-300 font-bold text-center mt-2">
                  Photo {currentImage + 1} of {images.length}
                </p>
              </div>

              {/* Navigation Arrows */}
              <button
                onClick={prevImage}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 backdrop-blur-sm rounded-full p-4 text-white hover:text-yellow-300 transition-all duration-300"
                aria-label="Previous image"
              >
                <i className="ri-arrow-left-line text-2xl"></i>
              </button>
              
              <button
                onClick={nextImage}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 backdrop-blur-sm rounded-full p-4 text-white hover:text-yellow-300 transition-all duration-300"
                aria-label="Next image"
              >
                <i className="ri-arrow-right-line text-2xl"></i>
              </button>
            </div>

            {/* Thumbnail Navigation */}
            <div className="flex justify-center space-x-2 mt-6 overflow-x-auto pb-2">
              {images.map((image, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImage(index)}
                  className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all duration-300 ${
                    currentImage === index 
                      ? 'border-yellow-400 scale-110 shadow-lg shadow-yellow-400/50' 
                      : 'border-white/30 hover:border-white/60'
                  }`}
                  aria-label={`View ${image.caption}`}
                >
                  <img
                    src={image.url}
                    alt={image.caption}
                    className="w-full h-full object-cover"
                    style={{
                      filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
                    }}
                  />
                </button>
              ))}
            </div>

            {/* Gallery Info */}
            <div className="text-center mt-4">
              <p className="text-white/80 text-sm">
                Use arrow keys or click thumbnails to navigate • ESC to close • Click outside to close
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AboutLexiSection;
